export type MediaProvider = 's3';

export type MediaLocator = {
  assetId?: string;
  provider?: MediaProvider | string;
  url?: string;
  contentType?: string;
};

const isLocalPreviewUrl = (value: string) => (
  value.startsWith('blob:')
  || value.startsWith('data:')
);

export function resolveMediaUrl(
  input: MediaLocator | string | null | undefined,
  _cdnServer: string,
  options: { allowLocalPreview?: boolean } = {},
) {
  const provider = typeof input === 'string' ? undefined : input?.provider;
  const raw = (typeof input === 'string' ? input : input?.url ?? '').trim();
  if (!raw) return '';

  if (isLocalPreviewUrl(raw)) {
    if (options.allowLocalPreview) return raw;
    throw new Error('Local preview media URL is not valid for durable media');
  }

  if (raw.startsWith('/fs/') || raw.startsWith('fs/')) {
    throw new Error('MSFS gateway prefix must be resolved by resolveMediaUrl');
  }

  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    return raw;
  }

  throw new Error('Media provider is required for relative media URLs');
}
